import React from "react";
import { Box, Button } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import SaveRoundedIcon from "@mui/icons-material/SaveRounded";
import SendRoundedIcon from "@mui/icons-material/SendRounded";
import { ButtonContainer } from "../styles/StyledComponents";

const StepNavigation = ({
  activeStep,
  totalSteps,
  onBack,
  onNext,
  isNextDisabled,
}) => {
  const isLastStep = activeStep === totalSteps - 1;
  const isFirstStep = activeStep === 0;

  const getButtonText = () => {
    if (isFirstStep) return "Procedi";
    if (isLastStep) return "Richiedi emissione";
    return "Avanti";
  };

  const getButtonIcon = () => {
    if (isLastStep) return <SendRoundedIcon />;
    return null;
  };

  return (
    <ButtonContainer>
      <Button
        variant="outlined"
        onClick={onBack}
        disabled={activeStep === 0}
        startIcon={<ArrowBackIcon />}
        sx={{
          borderColor: "#ff9800",
          color: "#ff6f00",
          "&:hover": {
            borderColor: "#ff6f00",
            backgroundColor: "rgba(255, 152, 0, 0.08)",
          },
        }}
      >
        Indietro
      </Button>
      <Button
        variant="contained"
        onClick={onNext}
        disabled={isNextDisabled}
        startIcon={getButtonIcon()}
        endIcon={!isLastStep && !isFirstStep ? <ArrowForwardIcon /> : null}
        sx={{
          backgroundColor: isLastStep ? "#4caf50" : "#ff9800",
          "&:hover": {
            backgroundColor: isLastStep ? "#388e3c" : "#ff6f00",
          },
          "&.Mui-disabled": {
            backgroundColor: (theme) =>
              theme.palette.mode === "light" ? "#e0e0e0" : "#4a4a4a",
            color: (theme) =>
              theme.palette.mode === "light"
                ? "rgba(0, 0, 0, 0.26)"
                : "rgba(255, 255, 255, 0.3)",
          },
        }}
      >
        {getButtonText()}
      </Button>
    </ButtonContainer>
  );
};

export default StepNavigation;
